// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"menu_l9UN5"};